import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";

import "./three-col-eighteen-stories.m.css";

export const OtherStory = ({
  story,
  showStorySeparator,
  defaultFallback,
  showTimestamp,
  showReadTime,
  sectionSlug,
}) => {
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const headlineStyleName = imageUrl ? "show-thumbnail" : "hide-thumbnail"; // Full width if no image

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName={`common-story ${showStorySeparator ? "" : "no-border"}`} key={story.id}>
      <Link href={href} target={target}>
        <div styleName="second-card">
          <div styleName={`left-column ${headlineStyleName}`}>
            {label && <Label story={story} />}

            {headline && <Headline styleName="heading" headline={headline} sectionSlug={sectionSlug} />}
            <PublishAndReadTime story={story} showTimestamp={showTimestamp} showReadTime={showReadTime} />
          </div>
          {imageUrl && (
            <div styleName="hero-image">
              <HeroImage
                story={story}
                headline={headline}
                aspectRatio={[[4, 3]]}
                iconSizes={{ height: 24, width: 24 }}
                imageUrl={imageUrl}
              />
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

OtherStory.propTypes = {
  story: object,
  showStorySeparator: bool,
  defaultFallback: bool,
  showTimestamp: bool,
  showReadTime: bool,
  sectionSlug: string,
};
